import { useTheme } from '@/contexts/ThemeContext';

/**
 * Returns the correct logo path based on the active color theme.
 * Uses black-text logo for light theme, white-text logo for dark/casino.
 */
export const useLogoSrc = () => {
  const { colorTheme } = useTheme();
  return colorTheme === 'light'
    ? '/gold-machine-black-logo.png'
    : '/gold-machine-logo.png';
};
